import { useState } from "react";



export default function OrderDropElementSmall({belongsTo, informAboutDrop, readyToReceive}) {

    function drop(){
        readyToReceive && informAboutDrop(belongsTo)
    }

    return (
    <div className='dnoItemDragTarget' onClick={drop} >
        <div className={'dnoItem ' + (readyToReceive ? " readyToReceive " : "")} >
                {readyToReceive 
                ?
                <hr className="dashed"></hr>
                :
                <hr className="solid"></hr>
                }
            </div>
    </div>
    )
}